<script setup lang="ts">
import Generic from '~/layouts/generic.vue'
import Header from '~/components/Layout/Header.vue'
import Banner from '~/components/Layout/Banner.vue'
import { useBannerStore } from '~/stores/useBannerStore';

const { isBannerVisible } = useBannerStore()
const { loadBrandList } = useBrandStore()
const { setCategory } = useCategoryStore()

useAsyncData('category', async () => setCategory(), { server: false })
useAsyncData('brand-list', async () => loadBrandList())
</script>

<template>
  <Generic>
    <a href="#main-content"
      class="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[9999] focus:px-4 focus:py-3 focus:bg-primary focus:text-white focus:font-bold focus:rounded-lg focus:shadow-lg">
      Vai al contenuto principale
    </a>
    <Header />
    <Banner v-if="isBannerVisible" />
    <Toast position="bottom-center" group="bc" />
    <main id="main-content" tabindex="-1" :class="`${isBannerVisible ? 'mt-28' : 'mt-20'} w-full bg-white`">
      <router-view />
    </main>
  </Generic>
</template>
